var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"topBac"}},[_c('div',{staticClass:"alreadyTitleRes"},[_c('p',{staticClass:"type"},[_vm._v(" "+_vm._s(_vm.workStatusList[_vm.orderState])+" ")]),_c('div',{staticClass:"typeWrap"},[_vm._t("orderTime")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }